import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/GithubAuthCallback';

export const GITHUB_AUTH = defineApiActionTypes(`${prefix}/GITHUB_AUTH`);
